import { useCognitoStore } from '@/src/types/CognitoStore'
import Script from 'next/script'
import { useEffect, useRef, useCallback } from 'react'
interface MainProps {
  onCaptchaSuccess: () => void
}

const AwsCaptchaComponent = ({ onCaptchaSuccess }: MainProps) => {
  const { cognito_captcha_api_key } = useCognitoStore()
  const captchaRef = useRef(null) // Ref for the CAPTCHA container

  const loadData = useCallback(async () => {
    // Ensure AWS WAF Integration is available
    if (typeof (window as any).AwsWafIntegration === 'undefined') {
      console.error('AWS WAF Integration is not loaded')
      return
    }

    try {
      // Fetch the protected resource
      const response = await (window as any).AwsWafIntegration.fetch('/protected-resource')
      if (captchaRef.current) {
        // Render the CAPTCHA
        ;(window as any).AwsWafCaptcha.renderCaptcha(captchaRef.current, {
          apiKey: cognito_captcha_api_key,
          onSuccess: () => {
            console.log('CAPTCHA solved, retrying request...')
            if (onCaptchaSuccess) {
              onCaptchaSuccess()
            }
          }
        })
      }
    } catch (error) {
      console.error('Error fetching protected resource: ', error)
    }
  }, [cognito_captcha_api_key, onCaptchaSuccess])

  useEffect(() => {
    loadData() // Fetch data when the component mounts
  }, [loadData])

  return (
    <div>
      <Script
        src="https://a91914f9d9ee.ap-southeast-2.captcha-sdk.awswaf.com/a91914f9d9ee/jsapi.js"
        strategy="lazyOnload"
        onLoad={() => console.log('AWS CAPTCHA script loaded again')}
      />
      <div id="captcha-container" ref={captchaRef}></div>{' '}
    </div>
  )
}

export default AwsCaptchaComponent
